import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const genitourinaryCondition: AnswerPathTreeNode = {
  path: 'genitourinaryCondition',
  children: [
    { path: 'hasCondition', nodeId: NodeIds.healthInsuredGenitourinaryHasCondition },
    { path: 'choices', nodeId: NodeIds.healthInsuredGenitourinaryChoices },
  ],
};
